var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20153 14.6383C6.20153 15.795 5.25818 16.7398 4.10132 16.7398C2.94462 16.7398 2 15.795 2 14.6383C2 13.4816 2.94477 12.5368 4.10148 12.5368H6.20169L6.20153 14.6383ZM7.26024 14.6383C7.26024 13.4816 8.20501 12.5368 9.36172 12.5368C10.5184 12.5368 11.4632 13.4814 11.4632 14.6383V19.8987C11.4632 21.0554 10.5186 22.0002 9.36172 22.0002C8.20501 22.0002 7.26024 21.0554 7.26024 19.8987V14.6383Z",
    fill: "#DC2626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36172 6.20153C8.20501 6.20153 7.26024 5.25818 7.26024 4.10132C7.26024 2.94462 8.20501 2 9.36172 2C10.5184 2 11.4632 2.94477 11.4632 4.10148V6.20169L9.36172 6.20153ZM9.36172 7.26024C10.5184 7.26024 11.4632 8.20501 11.4632 9.36172C11.4632 10.5184 10.5186 11.4632 9.36172 11.4632H4.10132C2.94462 11.4632 2 10.5186 2 9.36172C2 8.20501 2.94477 7.26024 4.10148 7.26024H9.36172Z",
    fill: "#3FABE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7988 9.36172C17.7988 8.20501 18.7421 7.26024 19.899 7.26024C21.0557 7.26024 22.0005 8.20501 22.0005 9.36172C22.0005 10.5184 21.0557 11.4632 19.899 11.4632H17.7988V9.36172ZM16.7401 9.36172C16.7401 10.5184 15.7953 11.4632 14.6386 11.4632C13.4819 11.4632 12.5371 10.5186 12.5371 9.36172V4.10132C12.5371 2.94462 13.4817 2 14.6386 2C15.7953 2 16.7401 2.94477 16.7401 4.10148V9.36172Z",
    fill: "#3ABA6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6386 17.7985C15.7953 17.7985 16.7401 18.7418 16.7401 19.8987C16.7401 21.0554 15.7953 22.0002 14.6386 22.0002C13.4819 22.0002 12.5371 21.0554 12.5371 19.8987V17.7985H14.6386ZM14.6386 16.7398C13.4819 16.7398 12.5371 15.795 12.5371 14.6383C12.5371 13.4816 13.4817 12.5368 14.6386 12.5368H19.899C21.0557 12.5368 22.0005 13.4814 22.0005 14.6383C22.0005 15.795 21.0557 16.7398 19.899 16.7398H14.6386Z",
    fill: "#FAAF0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackLogo);
export default __webpack_public_path__ + "static/media/slack-logo.a126ea343c7ec193250421b42ba23efb.svg";
export { ForwardRef as ReactComponent };